import { apiManager } from './apiManager';

export const updateUserKeys = async (keys) => {
    if (!keys || typeof keys !== 'object' || Object.keys(keys).length === 0) {
        throw new Error("Invalid request: 'keys' object with at least one key is required.");
    }

    try {
        return await apiManager.updateAccountKeys(keys);
    } catch (error) {
        console.error('[workspaceAccountManagement] Failed to update user keys:', error);
        throw error;
    }
};

export const deleteUserApiKey = async (keyName) => {
    if (!keyName || typeof keyName !== 'string') {
        throw new Error("Invalid request: 'keyName' is required.");
    }

    try {
        return await apiManager.deleteApiKey(keyName);
    } catch (error) {
        console.error(`[workspaceAccountManagement] Failed to delete user API key '${keyName}':`, error);
        throw error;
    }
};